import { api } from 'services/api/api'

const Get = async (username: string) => {
  return api.get(`/games/user/email/${username}`).then((data) => data.data)
}

export default {
  get: Get
}
